import React from 'react';
import { NavLink } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa'; // Example: Font Awesome icons
import * as MdIcons from 'react-icons/md'; // Example: Material Design icons
import './MainMenu.css'; // We'll create this file for styling

const menuItems = [
  { path: '/', name: 'Home', icon: <FaIcons.FaHome /> },
  { path: '/picture-description', name: 'Picture Description', icon: <MdIcons.MdImage /> },
  { path: '/proverbs', name: 'Proverbs', icon: <FaIcons.FaBookOpen /> },
  { path: '/auditory-comprehension', name: 'Listening Task', icon: <FaIcons.FaHeadphonesAlt /> },
  // Add other exercises here as you create routes for them
  // { path: '/repetition', name: 'Repetition', icon: <MdIcons.MdRepeat /> },
];

function MainMenu() {
  return (
    <nav className="main-menu">
      <div className="menu-header">
        {/* Optional: Add a logo or title */}
        <FaIcons.FaBrain size="2em" className="menu-logo-icon"/>
        <span className="menu-title">SLP Sidekick</span>
      </div>
      <ul>
        {menuItems.map((item, index) => (
          <li key={index}>
            <NavLink
              to={item.path}
              // `end` prop is important for the root path "/" to avoid matching all paths
              end={item.path === '/'}
              // Style the active link using the 'active' class provided by NavLink
              className={({ isActive }) => "menu-link" + (isActive ? " active" : "")}
            >
              <span className="menu-icon">{item.icon}</span>
              <span className="menu-text">{item.name}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      {/* Optional: Footer or other elements */}
      <div className="menu-footer">
         {/* You could add version info or links */}
         <small>&copy; {new Date().getFullYear()}</small>
      </div>
    </nav>
  );
}

export default MainMenu;